
import { fetchAchievements } from '../../service/AchievementsService';
import { updateField, getField } from 'vuex-map-fields';

export default {
    namespaced: true,
    state() {
        return {
            achievements: []
        }
    },
    getters: {
        getField,
        achievements: state => state.achievements
    },
    mutations: {
        updateField,
        setAchievements(state, payload) {
            state.achievements = payload;
        }
    },
    actions: {
        async fetch({ commit }, accesstoken) {
            const response = await fetchAchievements(accesstoken);
            //console.log(response);
            commit("setAchievements", response);
        }
    }
};